import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=63c3bffc&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=63c3bffc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c3bffc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63c3bffc')) {
      api.createRecord('63c3bffc', component.options)
    } else {
      api.reload('63c3bffc', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=63c3bffc&scoped=true&", function () {
      api.rerender('63c3bffc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24d3Wi1Kovvmu/JS/teamMember.vue"
export default component.exports